import type { CSSProperties, ReactNode } from "react";

interface Props {
  /** 이미지 src. children 을 주면 그걸 대신 렌더(video 등). */
  src?: string | null;
  alt?: string;
  children?: ReactNode;
  /** 출력 비율 — 기본 3:4 */
  aspect?: { w: number; h: number };
  /** 좌하단 브랜드(명조) */
  brand: string;
  /** 우하단 라벨(스타일명 등) */
  label?: string;
  /** fit: 컨테이너 높이에 맞춤(split__media 안) · sm: 고정 소형 · auto: 폭 따라감 */
  size?: "fit" | "sm" | "auto";
  tilt?: -1 | -3 | 0;
  className?: string;
  overlay?: ReactNode;
}

/**
 * 인화된 사진 프레임 — 흰 테두리 + 하단 캡션. 결과·수령·처리 화면이 공유.
 */
export function PhotoPrint({
  src,
  alt = "",
  children,
  aspect = { w: 3, h: 4 },
  brand,
  label,
  size = "fit",
  tilt = 0,
  className,
  overlay,
}: Props) {
  const ar = aspect.w / aspect.h;
  const style = {
    "--ar": String(ar),
    "--ar-css": `${aspect.w} / ${aspect.h}`,
    transform: tilt ? `rotate(${tilt}deg)` : undefined,
  } as CSSProperties;
  const cls = ["print", `print--${size}`, className ?? ""].filter(Boolean).join(" ");
  return (
    <figure className={cls} style={style}>
      <div className="print__pic">
        {children ?? (src ? <img src={src} alt={alt} draggable={false} /> : null)}
        {overlay}
      </div>
      <figcaption className="print__cap">
        <b>{brand}</b>
        {label ? <span>{label}</span> : null}
      </figcaption>
    </figure>
  );
}
